<template>
	<div class="d-flex flex-column h-100">
		<header class="masthead mb-auto">
			<nav class="navbar navbar-expand-lg navbar-dark bg-no-trans ">
				<div class="container">
					<a class="navbar-brand" href="/#/">
						<img src="../../assets/img/logo.png" alt="Logo" />
					</a>
					<div class="my-2 my-lg-0">
						<button
							class="btn btn-light btn-sm my-2 my-sm-0"
							@click="gotoSingin"
						>
							Login
						</button>
					</div>
				</div>
			</nav>
		</header>
		<section class="py-5">
			<div class="container">
				<div class="row d-flex justify-content-center">
					<div class="col-md-6">
						<ul class="list-group checkout-list-group">
							<li class="list-group-item">
								<p class="my-4 cardTitle">
									Set up your credit or debit card
								</p>
							</li>
							<li class="list-group-item">
								<div
									class="row d-flex  align-items-center justify-content-between"
								>
									<div class="col-auto">
										<span class="img"
											><img src="../../assets/img/mastercard.png"
										/></span>
										<span class="img"
											><img src="../../assets/img/visa.png"
										/></span>
										<span class="img"
											><img src="../../assets/img/Discover-card.png"
										/></span>
										<span class="img"
											><img src="../../assets/img/amex.png"
										/></span>
									</div>
								</div>
							</li>

							<li class="list-group-item">
								<form>
									<div class="form-group">
										<input
											type="text"
											class="form-control"
											placeholder="First Name"
										/>
									</div>
									<div class="form-group">
										<input
											type="text"
											class="form-control"
											placeholder="Last Name"
										/>
									</div>
									<div class="form-group">
										<input
											type="text"
											class="form-control"
											placeholder="Card Number"
										/>
									</div>
									<div class="form-group">
										<input
											type="text"
											class="form-control"
											placeholder="Expiration Date (MM/YY)"
										/>
									</div>
									<div class="form-group">
										<input
											type="text"
											class="form-control"
											placeholder="Security Code (CVV)"
										/>
										<img src="../../assets/img/cvvcode.svg" class="cvvImage" alt="">
									</div>

									<div class="form-group">
										<input
											type="text"
											class="form-control"
											placeholder="Postal Code"
										/>
										<img src="../../assets/img/information.svg" class="infoImg" alt="">
									</div>
								</form>
							</li>

							<li class="list-group-item">
								<div class="basicPlanWrapper">
									<p class="basicPlanPrice">$7 Monthly</p>
									<p class="basicPlanText">Basic Plan</p>
								</div>
							</li>

							<li class="list-group-item">
								<p>
									By checking the checkbox below, you agree to our Terms of Use,
									Privacy Statement, and that you are over 18. You may cancel at
									any time. Ibakatv will automatically continue your membership
									and charge the membership fee (currently ₦7) to your payment
									method on a monthly basis until you cancel.
								</p>
								<div class="custom-control custom-checkbox mt-3">
									<input
										type="checkbox"
										v-model="checked"
										class="custom-control-input"
										id="customCheck1"
									/>
									<label class="custom-control-label" for="customCheck1"
										>I Agree</label
									>
								</div>
								<div class="my-3">
									<button class="btn btn-primary btn-block">
										Continue
									</button>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
export default {
	name: "SelectPaymentDsp",
	components: {},
	created() {
		this.$store.commit("showPopup", false);
		this.$store.commit("showdefaultFooter", false);
		this.$store.commit("showdefaultnav", false);
		this.config = this.$store.getters.getGlobalConfigs;
		this.getSubsById(this.$route.params.pid);
		const countrycode = this.$store.getters.getGlobalConfigs.country_code;
		var list = this.$store.getters.getGlobalConfigs.payment_options;
		var countryList = JSON.parse(list);
		for (let index = 0; index < countryList.options.length; index++) {
			const CountryWhiteListed = countryList.options[index].countries.find(
				(arr) => {
					if (countrycode == arr) {
						this.paymentOptionList = countryList.options[index].paymentOptions;
						return true;
					} else {
					}
				}
			);
		}
		if (this.paymentOptionList == null) {
			this.paymentList = countryList.default;
		} else {
			this.paymentList = this.paymentOptionList;
		}
	},
	computed: {
		showFlutterWave() {
			return this.$store.getters.isCountryWhiteListed;
		},
		showDpo() {
			return this.$store.getters.isCountryDpoWhiteListed;
		},
		showStripe() {
			return this.$store.getters.isCountryStripeWhiteListed;
		},
		showBraintree() {
			return this.$store.getters.isCountryBraintreeWhiteListed;
		},
	},
	methods: {
		getSubsById(pid) {
			this.packages = this.$store.state.packages;
			this.currentPackageObj = this.packages.find((ele) => ele.id == pid);
			return this.currentPackageObj;
		},

		setBraintreeCard() {
			this.$router.push(
				"/payment/" + this.$route.params.sid + "/" + this.$route.params.pid
			);
		},
		setCard() {
			this.$router.push(
				"/stripepayment/" +
					this.$route.params.sid +
					"/" +
					this.$route.params.pid
			);
		},
		openFlutterWave() {
			this.$router.push(
				"/flutterwavepayment/" +
					this.$route.params.sid +
					"/" +
					this.$route.params.pid
			);
		},
		setCash() {
			this.$router.push(
				"/cashpayment/" + this.$route.params.pid + "/" + this.$route.params.sid
			);
		},
		gotoSingin() {
			this.$router.push("/signup");
		},

		showCardByCountry(provider) {
			if (provider == "stripe") {
				this.$router.push(
					"/stripepayment/" +
						this.$route.params.sid +
						"/" +
						this.$route.params.pid
				);
			} else if (provider == "flutterwave") {
				this.$router.push(
					"/flutterwavepayment/" +
						this.$route.params.sid +
						"/" +
						this.$route.params.pid
				);
			} else if (provider == "braintree") {
				this.$router.push(
					"/payment/" + this.$route.params.sid + "/" + this.$route.params.pid
				);
			} else if (provider == "dpo") {
				tthis.$router.push(
					"/process-dpo/" +
						this.$route.params.sid +
						"/" +
						this.$route.params.pid
				);
			} else if (provider == "manual") {
				this.$router.push(
					"/cashpayment/" +
						this.$route.params.pid +
						"/" +
						this.$route.params.sid
				);
			}
		},
	},

	data() {
		return {
			showforgotpasswordErr: false,
			forgotpasswordErr: "",
			isActive: false,
			doforgotpassword: true,
			userid: "",
			password: "",
			bgImg: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
			config: null,
			packages: null,
			currentPackageObj: null,
			paymentList: null,
			paymentOptionList: null,
		};
	},
};
</script>
<style scoped>
.pointer {
	cursor: pointer;
}
.card-body {
	cursor: pointer;
}
.card-body:hover,
.card-body:focus {
	border-radius: 10px;
	border-color: #679f3d !important;
	-webkit-box-shadow: 0 0 0 0.2rem rgba(149, 209, 76, 0.596) !important;
	box-shadow: 0 0 0 0.2rem rgba(144, 206, 69, 0.61) !important;
}

.py-5 {
	padding-top: 8rem !important;
	padding-bottom: 8rem !important;
	min-height: 100vh;
}
.form-control {
	background: #ffffff 0% 0% no-repeat padding-box;
	border: 1px solid #aaaaaa !important;
	border-radius: 4px;
	opacity: 1;
	width: 400px;
}
input::placeholder {
	text-align: left;
	font: normal normal normal 12px/17px Averta-Regular;
	letter-spacing: 0px;
	color: #181917;
}
/* .basicPlanWrapper {
	background: #ffffff 0% 0% no-repeat padding-box;
	opacity: 1;
} */
.basicPlanPrice {
	font: normal normal normal 14px/12px Averta-Semibold;
	letter-spacing: 0px;
	color: #181917;
	opacity: 0.85;
}
.basicPlanText {
	font: normal normal normal 11px/11px Averta-Regular;
	letter-spacing: 0px;
	color: #181917;
	opacity: 0.85;
}
.checkout-list-group .list-group-item:nth-child(even) {
	background-color: #ffffff;
}
.cardTitle {
	font: normal normal normal 18px Averta-Semibold !important;
	letter-spacing: 0px;
	color: #181917;
	opacity: 0.8;
}
.btn-block {
	width: 350px !important;
	height: 40px;
	background: #80b440 0% 0% no-repeat padding-box;
	border-radius: 16px;
	opacity: 1;
	margin-left: 52px;
}
.cvvImage{
	position:absolute;
	right: 128px !important;
    bottom: 90px !important;
}
.infoImg{
	position:absolute;
	right: 78px !important;
    bottom: 21px !important;
}
</style>
